"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.h = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var attribute_1 = tslib_1.__importDefault(require("../common/attribute"));
function h(type, props) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    var mergedProps = props;
    if ((props === null || props === void 0 ? void 0 : props.className) && typeof type === 'string' && !window.__dui_disable_scoped_attribute__) {
        mergedProps[attribute_1.default] = props.className;
    }
    return react_1.createElement.apply(void 0, tslib_1.__spreadArrays([type, mergedProps], children));
}
exports.h = h;
